module.exports = __webpack_public_path__ + "static/media/Fauzi.cfb3893d.jpeg";